var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('sub-title',{staticClass:"title",attrs:{"title":"荣誉资质"}}),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.webInfo.about.ryzz),function(item,index){return _c('div',{key:index,staticClass:"item_img"},[_c('img',{attrs:{"src":item}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }